import { MatchCtaLink } from '../MatchCtaLink';

export type EmptyStateVariant = 'no-area-results' | 'filters-too-narrow';

export type EmptyStateProps = {
  variant: EmptyStateVariant;
};

export function EmptyState({ variant }: EmptyStateProps) {
  const isNoArea = variant === 'no-area-results';
  const headline = isNoArea ? 'No advisors found in this area' : 'No advisors match your filters';
  const description = isNoArea
    ? "We didn't find registered advisors matching this zip code or nearby areas. Try a different zip code, or get matched with an advisor through NerdWallet Advisors Match."
    : 'Try adjusting or clearing your filters above to see more results.';

  return (
    <div className="px-6 py-12 text-center md:py-16">
      <h2 className="typography-large-headline mb-2 text-xl md:text-2xl">{headline}</h2>
      <p
        className={`typography-text mx-auto max-w-[480px] text-[var(--content-neutral-dark)] ${
          isNoArea ? 'mb-6' : ''
        }`}
      >
        {description}
      </p>
      {isNoArea ? (
        <MatchCtaLink
          label="Find My Advisor - It's Free"
          actionSection="empty_state_no_area"
          size="lg"
          withShadow
        />
      ) : null}
    </div>
  );
}
